import { FETCH_MTOKNA_POINTS, CLEAN_MTOKNA_POINTS, CHANGE_MTOKNA_POINT, DELETE_MTOKNA_POINT, CHANGE_MTOKNA_POINT_PAGE_STATUS } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const MTOKNA_POINTS_DEFAULT_STATE = {};

const MtoknaPointsReducer = (state = MTOKNA_POINTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_POINTS:
            return payload;

        case CHANGE_MTOKNA_POINT:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, data: payload.data };
                }

                return item;
            }) };

        case CHANGE_MTOKNA_POINT_PAGE_STATUS:
            return { ...state, pages: { ...state.pages, [payload.id]: payload.status } };

        case CLEAN_MTOKNA_POINTS:
        case DELETE_MTOKNA_POINT:
            return MTOKNA_POINTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaPointsReducer;
